import { render, staticRenderFns } from "./GoodsCategories.vue?vue&type=template&id=619e2842"
import script from "./GoodsCategories.vue?vue&type=script&lang=js"
export * from "./GoodsCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports